module.exports = "../../app/cells/components/filter_suggestions_cell.rb";